module.exports = __webpack_public_path__ + "static/media/pin-controls.7809d90f.svg";